import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import QuickFacts from "@/pages/home/components/QuickFacts";
import StorySection from "@/pages/home/components/StorySection";
import CharacterSection from "@/pages/home/components/CharacterSection";
import HighlightSection from "@/pages/home/components/HighlightSection";
import ContentGuide from "@/pages/home/components/ContentGuide";
import WatchSection from "@/pages/home/components/WatchSection";
import FaqSection from "@/pages/home/components/FaqSection";
import WatchTipsSection from "@/pages/home/components/WatchTipsSection";
import FooterSection from "@/pages/home/components/FooterSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <SiteHeader />
      <main>
        <HeroSection />
        <QuickFacts />
        <StorySection />
        <CharacterSection />
        <HighlightSection />
        <ContentGuide />
        <WatchSection />
        <FaqSection />
        <WatchTipsSection />
      </main>
      <FooterSection />
    </div>
  );
}